import React from 'react';
import { FilterContainer } from '@components/Common/EntryFilters';
import DateFilterControlled, { DateFilterValues } from '@components/Common/EntryFilters/DateFilterControlled';
import { Columns } from '@components/Common/SharedStyles';
import { compareDatesAsc, endOfDayLocal, toIsoUtc } from '@helpers/dateUtils';

interface AdminFiltersControlledProps {
  value: DateFilterValues;
  onChange: (value: DateFilterValues) => void;
}

const AdminFiltersControlled: React.FC<AdminFiltersControlledProps> = ({ value, onChange }) => (
  <FilterContainer>
    <Columns>
      <DateFilterControlled value={value} onChange={onChange} />
    </Columns>
  </FilterContainer>
);

export default AdminFiltersControlled;

/**
 * Filter items by date range.
 * Moved from AdminFilters.tsx during Redux cleanup.
 */
export const filterItemsByDateTime = <T extends {}>(
  things: T[],
  getDate: (x: T) => string,
  dateFilter: DateFilterValues
): T[] => {
  const { startDate, endDate } = dateFilter;
  let filtered = things;

  if (startDate) {
    // Keep items where item date >= startDate
    filtered = filtered.filter(e => compareDatesAsc(getDate(e), startDate) >= 0);
  }

  if (endDate) {
    // Normalize end date to end of day, then keep items where item date <= endDate
    const endDateNormalized = toIsoUtc(endOfDayLocal(endDate));
    filtered = filtered.filter(e => compareDatesAsc(getDate(e), endDateNormalized) <= 0);
  }

  return filtered;
};
